var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('div',_vm._b({ref:"lottie",staticClass:"lottier-container"},'div',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }